import React, { useMemo, useState, createContext, useEffect } from 'react';

const InsightsContext = createContext({});

export function InsightsProvider({ children }) {
  const [displayMenu, setDisplayMenu] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [selectedIndustry, setSelectedIndustry] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [filtersArray, setFiltersArray] = useState([selectedFilter, selectedIndustry]);
  const [selectedTag, setSelectedTag] = useState('');

  useEffect(() => {
    setFiltersArray([selectedFilter, selectedIndustry, selectedTag, searchValue]);
  }, [selectedFilter, selectedIndustry, selectedTag, searchValue]);

  const memo = {
    displayMenu,
    setDisplayMenu,
    toggle,
    setToggle,
    selectedFilter,
    setSelectedFilter,
    selectedIndustry,
    setSelectedIndustry,
    filtersArray,
    selectedTag,
    setSelectedTag,
    searchValue,
    setSearchValue,
  };

  const value = useMemo(() => memo, [memo]);

  return <InsightsContext.Provider value={value}>{children}</InsightsContext.Provider>;
}

export default InsightsContext;
